import { Card } from "react-bootstrap";
import { Navigate, useNavigate } from "react-router-dom";

export const FuturePrograms = () => {
  const navigate = useNavigate();
  const data = [
    {
      id: 1,
      title: "Under Graduate Programms",
      tabName: "BBA",
      // link: "https://mibmpune.ac.in/academics/courses#",
    },
    {
      id: 2,
      title: "Post Graduate Programms",
      tabName: "MBA",
      // link: "https://mibmpune.ac.in/academics/courses#",
    },
    {
      id: 3,
      title: "Ph.D. Programms",
      tabName: "Ph.D",
      // link: "https://mibmpune.ac.in/academics/courses",
    },
    { id: 4, title: "Diploma & Certifications" },
  ];

  const handleClick = (tabName) => {
    if (!tabName) return;
    sessionStorage.setItem("menuName", tabName);
    navigate("/academics/courses", "_blank"); // adjust route to your CourseData page
  };

  return (
    <div className="future-programs-container">
      <h2>Future-Focused Education Program</h2>
      <div className="Programcard-container">
        {data.map((item) => (
          <Card
            key={item.id}
            className="Programscards"
            onClick={() => handleClick(item.tabName)}
            style={{ cursor: item.tabName ? "pointer" : "default" }}
          >
            <h3 className="programTitle">{item.title}</h3>
          </Card>
        ))}
      </div>
    </div>
  );
};
